import { useForm } from 'react-hook-form';

import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

import { Input } from '@/components/form/Input';
import { FormBlock } from '@/components/FormBlock';
import { useZustandSync } from '@/hooks/useZustandSync';
import { authStore } from '@/stores/auth';
import useProductStore, { productStore } from '@/stores/productStore';

import { HelpText } from '../ui/HelpText';

const productEmailSchema = z.object({
  email: z
    .email({ message: 'E-mail inválido' })
    .max(254, { message: 'O e-mail deve ter no máximo 254 caracteres' })
    .refine(val => !val.endsWith('@eduzz.com') && !val.endsWith('@eduzz.com.br'), {
      message: 'E-mails com domínio @eduzz.com e @eduzz.com.br não são permitidos'
    })
});
type ProductEmailFormValues = z.infer<typeof productEmailSchema>;

const FIELD_NAME = 'email';

export default function ProductEmail() {
  const form = useForm<ProductEmailFormValues>({
    resolver: zodResolver(productEmailSchema),
    mode: 'onChange',
    defaultValues: { [FIELD_NAME]: productStore.getState().email || authStore.getState().currentUser?.email || '' }
  });

  useZustandSync<ProductEmailFormValues>(form.control, data => ({
    [FIELD_NAME]: data[FIELD_NAME]
  }));

  const productEmail = useProductStore(d => d[FIELD_NAME]);

  return (
    <FormBlock name='product-email' form={form} title='E-mail de Suporte' preview={<>{productEmail}</>}>
      <Input
        label='E-mail de suporte para seus clientes'
        id='product-email'
        placeholder='E-mail de Suporte'
        inputMode='email'
        name={FIELD_NAME}
      />

      <HelpText>Será exibido durante a compra para que seus clientes entrem em contato com você.</HelpText>
    </FormBlock>
  );
}
